import { render, staticRenderFns } from "./dth-checkout.vue?vue&type=template&id=571f34f8&scoped=true"
import script from "./dth-checkout.vue?vue&type=script&lang=js"
export * from "./dth-checkout.vue?vue&type=script&lang=js"
import style0 from "./dth-checkout.vue?vue&type=style&index=0&id=571f34f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f34f8",
  null
  
)

export default component.exports